interface BlockSkipOptions {
  className?: string;
  skipText?: string;
  skipSelector?: string;
}

export class BlockSkip {
  private el: HTMLElement;
  private buttonEl: HTMLButtonElement;
  private options: Required<BlockSkipOptions>;
  private config: {
    focusableSelectors: string[];
  };

  constructor(selector: string, options: BlockSkipOptions = {}) {
    this.el = document.querySelector(selector) as HTMLButtonElement;
    this.config = {
      focusableSelectors: ['a[href]', 'button', 'textarea', 'input', 'select', '[tabindex]:not([tabindex="-1"])'],
    };
    this.options = {
      className: options.className || '',
      skipText: options.skipText || this.el.dataset.skipText || '',
      skipSelector: options.skipSelector || '', // ブロックスキップによるスキップ後のフォーカス対象
    };
    this.buttonEl = document.createElement('button');

    if (!this.el) {
      console.error(`Element not found: ${selector}`);
      return;
    }

    this.el.dataset.skipText = '';

    this.bind();
    this.initialize();
  }

  private bind(): void {
    this.handleBlockSkip = this.handleBlockSkip.bind(this);
  }

  private initialize(): void {
    // ボタン要素の初期化
    this.buttonEl.type = 'button';
    this.buttonEl.setAttribute('aria-label', this.options.skipText);
    this.buttonEl.className = `${this.options.className}`.trim();

    // イベントリスナーの追加
    this.buttonEl.addEventListener('pointerdown', this.handleBlockSkip);
    this.buttonEl.addEventListener('keydown', this.handleBlockSkip);

    // コンテナ要素に追加
    this.el.appendChild(this.buttonEl);
  }

  private getNextFocusableElement(currentElement: Element): Element {
    const focusableElements: Element[] = Array.from(
      document.querySelectorAll(this.config.focusableSelectors.join(',')),
    ).filter((el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));

    const currentIndex: number = focusableElements.indexOf(currentElement);

    console.log(focusableElements, currentElement, currentIndex);

    return focusableElements[(currentIndex + 1) % focusableElements.length];
  }

  private findFirstFocusableElement(targetElement: HTMLElement): HTMLElement | null {
    return targetElement.querySelector(this.config.focusableSelectors.join(','));
  }

  private getPreviousFocusableElement(currentElement: Element): Element {
    const focusableElements: Element[] = Array.from(
      document.querySelectorAll(this.config.focusableSelectors.join(',')),
    ).filter((el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));

    const currentIndex: number = focusableElements.indexOf(currentElement);
    return focusableElements[(currentIndex - 1 + focusableElements.length) % focusableElements.length];
  }

  /**
   * 非表示のUIを除外するような処理は、実現したい事に対して不確実性が高いため使わない
   */
  // private filterVisibleElements(elements: HTMLElement[]): HTMLElement[] {
  //   return elements.filter((el) => {
  //     const style = window.getComputedStyle(el);
  //     return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
  //   });
  // }

  private handleBlockSkip(e: Event): void {
    if (!this.options.skipSelector || (e instanceof KeyboardEvent && !/^(Space|Enter)$/.test(e.code))) {
      return;
    }

    e.preventDefault();

    const target = document.querySelector(this.options.skipSelector) as null | HTMLElement;
    const fallbackTarget = document.querySelector('main');

    if (!fallbackTarget) return;

    const focusTarget = target || this.findFirstFocusableElement(fallbackTarget);

    if (!focusTarget) {
      console.error('No focusable element found');
      return;
    }

    focusTarget.focus();
  }

  public destroy(): void {
    this.buttonEl.removeEventListener('pointerdown', this.handleBlockSkip);
    this.buttonEl.removeEventListener('keydown', this.handleBlockSkip);
    if (this.buttonEl.parentNode) {
      this.buttonEl.parentNode.removeChild(this.buttonEl);
    }
  }
}
